import { TCreateAppConfig, TQueryAppConfig, TUpdateAppConfig } from '@src/modules'

import { request } from './config'

export const getAppConfigs = (params: TQueryAppConfig, token: string) =>
  request({ url: 'app-config', method: 'GET', params }, { token })

export const createAppConfig = (body: TCreateAppConfig, token: string) =>
  request({ url: 'app-config', method: 'POST', data: body }, { token })

export const patchAppConfig = (id: number, body: TUpdateAppConfig, token: string) =>
  request({ url: `app-config/${id}`, method: 'PATCH', data: body }, { token })

export const deleteAppConfig = (id: number, token: string) =>
  request({ url: `app-config/${id}`, method: 'DELETE' }, { token })
